import { casesTypes, caseDetailTypes, caseAnnotationTypes, caseResolveTypes, clearCaseResolveResponseType, setAgentCasesFiltersType } from './actions'
import moment from 'moment'


export const agentCasesFilterDefaults = {
    statusFilter: 'all',
    dateFilter: 'all',
    agentFilter: '',
    custodianFilter: '',
    order: {
        field: 'CreatedDate',
        direction: 'desc',
    }
}


const initialState = {
    isFetching: false,
    error: false,
    cases: [],
    agents: [],
    custodians: [],
    filters: agentCasesFilterDefaults,
}


const parseUtcMoment = (value) => {
    if (!value) {
        return null
    }

    const parsed = moment.utc(value, ['DD.MM.YYYY', 'YYYY-MM-DD', moment.ISO_8601], true)
    if (parsed.isValid()) {
        return parsed
    }

    const fallback = moment.utc(value)
    return fallback.isValid() ? fallback : null
}

const normalizeCaseDates = (caseItem) => {
    if (!caseItem || typeof caseItem !== 'object') {
        return caseItem
    }

    const createdValue = caseItem.CreatedDate || caseItem.created_at
    const dueValue = caseItem.DueDate || caseItem.due_date

    return {
        ...caseItem,
        CreatedDate: parseUtcMoment(createdValue),
        DueDate: parseUtcMoment(dueValue),
    }
}


export function agentCases(state = initialState, action) {
    switch(action.type) {

        case casesTypes.REQUEST:
            state = {
                ...state,
                isFetching: true,
            }
            return state

        case casesTypes.ERROR:

            state = {
                ...state,
                isFetching: false,
                error: true,
                errorMessage: action.response && action.response.message,
            }
            return state

        case casesTypes.RECEIVE:
            const receivedCases = action.data && action.data.list ? action.data.list.map(normalizeCaseDates) : []
            state = {
                ...state,
                isFetching: false,
                is_boss: action.data.is_boss, 
                cases: receivedCases,
                agents: [... new Set(receivedCases.map(caseItem => caseItem.AdvisorName || caseItem.AdvisorSSN || caseItem.AdvisorCode).filter(Boolean))],
                custodians: [... new Set(receivedCases.map(caseItem => caseItem.CustodianName).filter(Boolean))],
            }
            return state

        case setAgentCasesFiltersType:
            state = {
                ...state,
                filters: {
                    ...(state.filters || agentCasesFilterDefaults),
                    ...(action.filters || {}),
                },
            }
            return state

        default:
            return state

    }
}


const caseDetailsInitialState = {
    isFetching: false,
    isPostingAnnotation: false,
    isResolvingCase: false,
    error: false,
    annotationPostError: false,
    caseResolveError: false,
    case: null,
    annotations: [],
    contract: null,
}


export function caseDetails(state = caseDetailsInitialState, action) {
    switch(action.type) {

        case caseDetailTypes.REQUEST:
            state = {
                ...state,
                isFetching: true,
                error: false,
            }
            return state

        case caseDetailTypes.ERROR:
            state = {
                ...state,
                isFetching: false,
                error: true,
                errorMessage: action.response && action.response.message,
            }
            return state

        case caseDetailTypes.RECEIVE:
            const receivedCase = action.data && action.data.Case ? normalizeCaseDates(action.data.Case) : null
            const receivedAnnotations = action.data && action.data.Annotations
                ? action.data.Annotations.map(annotation => ({
                    ...annotation,
                    CreatedDate: parseUtcMoment(annotation.CreatedDate || annotation.created_at),
                }))
                : []
            state = {
                ...state,
                isFetching: false,
                error: false,
                annotationPostError: false,
                data: action.data,
                case: receivedCase,
                annotations: receivedAnnotations,
                contract: action.data && action.data.Contract ? action.data.Contract : null,
                customer: action.data && action.data.Customer ? action.data.Customer : null,
                contractFilesList: action.data && action.data.ContractFilesList ? action.data.ContractFilesList : [],
            }
            return state

        case caseAnnotationTypes.REQUEST:
            state = {
                ...state,
                isPostingAnnotation: true,
                annotationPostError: false,
            }
            return state

        case caseAnnotationTypes.ERROR:
            state = {
                ...state,
                isPostingAnnotation: false,
                annotationPostError: true,
                annotationPostErrorMessage: action.response && action.response.message,
            }
            return state

        case caseAnnotationTypes.RECEIVE:
            const createdDate = moment.utc()
            const axCasePayload = action.data && action.data.Case ? action.data.Case : {}
            const newAnnotation = {
                Type: axCasePayload.Subject || (action.payload && action.payload.subject) || 'Frá ráðgjafa',
                Description: axCasePayload.Description || (action.payload && action.payload.description) || '',
                CreatedDate: parseUtcMoment(axCasePayload.CreatedDate) || createdDate,
                CreatedBy: axCasePayload.CreatedBy || ''
            }

            state = {
                ...state,
                isPostingAnnotation: false,
                annotationPostError: false,
                annotationPostErrorMessage: null,
                annotationPostResponse: action.data,
                annotations: [newAnnotation, ...(state.annotations || [])],
            }
            return state

        case caseResolveTypes.REQUEST:
            state = {
                ...state,
                isResolvingCase: true,
                caseResolveError: false,
            }
            return state

        case caseResolveTypes.ERROR:
            state = {
                ...state,
                isResolvingCase: false,
                caseResolveError: true,
                caseResolveErrorMessage: action.response && action.response.message,
            }
            return state

        case caseResolveTypes.RECEIVE:
            const resolvedCasePayload = action.data && action.data.Case ? action.data.Case : {}
            state = {
                ...state,
                isResolvingCase: false,
                caseResolveError: false,
                caseResolveErrorMessage: null,
                caseResolveResponse: action.data,
                case: normalizeCaseDates({
                    ...(state.case || {}),
                    ...resolvedCasePayload,
                }),
            }
            return state

        case clearCaseResolveResponseType:
            state = {
                ...state,
                caseResolveResponse: null,
                caseResolveError: false,
                caseResolveErrorMessage: null,
            }
            return state

        default:
            return state
    }
}
